import type { IconDef } from '../types';

export const clock: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0C18.6218 0 24 5.37818 24 12C24 18.6218 18.6218 24 12 24C5.37818 24 0 18.6218 0 12C1.93642e-07 5.37818 5.37818 1.93648e-07 12 0ZM17.1816 3.66504C12.9271 1.0144 7.14522 2.60741 4.28711 7.21094C1.429 11.8037 2.56384 17.6948 6.81836 20.3457C11.0729 22.9964 16.8548 21.3924 19.7129 16.7998C22.5709 12.2071 21.4361 6.31591 17.1816 3.66504ZM12.2949 5.45508C12.8949 5.4769 13.3646 5.98984 13.3428 6.58984L13.1133 11.7939L15.6006 14.2041C16.0369 14.6186 16.0475 15.3167 15.6221 15.7422C15.393 15.9713 15.0875 16.0802 14.793 16.0693C14.5313 16.0584 14.2695 15.9824 14.0732 15.7861L11.2373 13.0264C11.0192 12.8082 10.8993 12.5027 10.9102 12.1973L11.1611 6.50293C11.1829 5.90303 11.6951 5.43344 12.2949 5.45508Z',
    },
  ],
};
